/** What a deletion is about to act on: records, previous revisions, or both. */
export interface RecordDeleteSelection {
  recordIds: number[];
  revisionIds: number[];
}

const RECORD_SINGULAR = 'Tem certeza que deseja deletar o registro?';
const RECORD_PLURAL = 'Tem certeza que deseja deletar os registros selecionados?';
const REVISION_SINGULAR = 'Tem certeza que deseja deletar a revisão?';
const REVISION_PLURAL = 'Tem certeza que deseja deletar as revisões selecionadas?';
const MIXED = 'Tem certeza que deseja deletar os registros e as revisões selecionados?';

/**
 * Title of the deletion confirmation. Previous revisions are selectable and
 * their selection survives collapsing the row, so the confirmation is the only
 * place that can tell the user what is about to go: it names records and
 * revisions apart instead of relying on what is visible on screen.
 */
export function buildRecordDeleteTitle({ recordIds, revisionIds }: RecordDeleteSelection): string {
  if (recordIds.length > 0 && revisionIds.length > 0) {
    return MIXED;
  }

  if (revisionIds.length > 0) {
    return revisionIds.length === 1 ? REVISION_SINGULAR : REVISION_PLURAL;
  }

  return recordIds.length === 1 ? RECORD_SINGULAR : RECORD_PLURAL;
}

export const RECORD_DELETE_DESCRIPTION = 'A ação não pode ser desfeita.';
